import { IconsProps } from '@/types/shared'
import React from 'react'

const CustomerSpamIcons: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M9 14.5C9.28333 14.5 9.52083 14.4042 9.7125 14.2125C9.90417 14.0208 10 13.7833 10 13.5C10 13.2167 9.90417 12.9792 9.7125 12.7875C9.52083 12.5958 9.28333 12.5 9 12.5C8.71667 12.5 8.47917 12.5958 8.2875 12.7875C8.09583 12.9792 8 13.2167 8 13.5C8 13.7833 8.09583 14.0208 8.2875 14.2125C8.47917 14.4042 8.71667 14.5 9 14.5ZM8 10.5H10V4.5H8V10.5ZM5.25 18.5L0 13.25V5.75L5.25 0.5H12.75L18 5.75V13.25L12.75 18.5H5.25ZM6.1 16.5H11.9L16 12.4V6.6L11.9 2.5H6.1L2 6.6V12.4L6.1 16.5Z"
                    fill="currentColor"
                />
            </svg>
        </div>
    )
}

export default CustomerSpamIcons
